import { styled, Grid } from '@orthly/ui-primitives';

export const Spotlight = styled(Grid)({
    boxShadow: '0 0 0 max(100vh, 100vw) rgba(0, 0, 0, 0.8)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    // TODO: Remove this when EPDPLT-3985 is resolved.
}) as unknown as typeof Grid;
